import type { HttpClient } from '../http/HttpClient'
import { equivalenceOf } from '@/domain/unit/Equivalence'
import type { EquivalenceRepository, QuotationEquivalence, RawEquivalence } from '@/domain/unit/Equivalence'

export class HttpEquivalenceRepository implements EquivalenceRepository {
  constructor(private http: HttpClient) {}

  async save(quotationLineId: number, equivalence: number | null): Promise<QuotationEquivalence> {
    const raw = await this.http.url(`purchases/quotation_lines/${quotationLineId}/equivalence`).body({ equivalence }).put<RawEquivalence>()
    return equivalenceOf(raw)
  }
}
